import { z } from 'zod';
import { defaultResponse } from '@/lib/generate-rules';
import { toTypedSchema } from '@vee-validate/zod';

export const numericMinMax = (min: number, max?: number) => {
  // Build number schema with min/max first
  let numberSchema = z
    .number({
      required_error: defaultResponse,
      invalid_type_error: 'Must be a number',
    })
    .min(min, { message: `Must be greater than or equal to ${min}` });

  if (max && max !== null) {
    numberSchema = numberSchema.max(max, { message: `Must be less than or equal to ${max}` });
  }

  // Wrap in preprocess AFTER min/max
  const schema = z.preprocess((val) => {
    if (val === '') return undefined; // treat empty string as missing
    if (typeof val === 'string') return Number(val); // convert numeric string
    return val; // keep numbers as is
  }, numberSchema);

  return toTypedSchema(schema);
};
